import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import InputMask from "react-input-mask";

import ProntuarioAtendimentos from "./ProntuarioAtendimentos";
import ProntuarioReunioes from "./ProntuarioReunioes";
import ProntuarioDocumentos from "./ProntuarioDocumentos";

import API from "../../../actions/api-helper";
import UI from "../../../actions/ui-helper";
import DataUtil from "../../../actions/data";

class Prontuario extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
    };
    if (this.props.match.params.id) {
      this.state.id = this.props.match.params.id;
    }
    this.uploaded = this.uploaded.bind(this);
    this.excluirAtendimento = this.excluirAtendimento.bind(this);
    this.excluirReuniao = this.excluirReuniao.bind(this);
    this.excluirDocumento = this.excluirDocumento.bind(this);
  }

  componentDidMount() {
    UI.loader("show");
    API.get("/prontuario/" + this.state.id).then((json) => {
      if (!DataUtil.validarData(json.data.paciente.dataNascimento)) {
        json.data.paciente.dataNascimento = "";
      }
      this.setState(json.data);
      UI.loader("hide");
    });
  }

  componentDidUpdate() {
    UI.inputHelpers();
  }

  uploaded(documento) {
    let documentos = this.state.documentos;
    documentos.push(documento);
    this.setState({ documentos: documentos });
  }

  excluirAtendimento(atendimento, index) {
    UI.confirm(
      "Atenção",
      "Tem certeza que deseja excluir o atendimento #" + atendimento.id + "?"
    ).then((confirma) => {
      if (confirma) {
        UI.loader("show", "Um momento...");
        API.delete("/atendimentos/" + atendimento.id)
          .then((json) => {
            UI.alert(json.success, json.message);
            if (json.success) {
              let resultado = this.state.atendimentos.filter(
                (value, i, arr) => {
                  return i !== index;
                }
              );
              this.setState({ atendimentos: resultado });
            }
            UI.loader("hide");
          })
          .catch((json) => {
            UI.alert(false, json.message);
            UI.loader("hide");
          });
      }
    });
  }

  excluirReuniao(reuniao, index) {
    UI.confirm(
      "Atenção",
      "Tem certeza que deseja excluir a reunião #" + reuniao.id + "?"
    ).then((confirma) => {
      if (confirma) {
        UI.loader("show", "Um momento...");
        API.delete("/reuniao/" + reuniao.id)
          .then((json) => {
            UI.alert(json.success, json.message);
            if (json.success) {
              let resultado = this.state.reunioes.filter((value, i, arr) => {
                return i !== index;
              });
              this.setState({ reunioes: resultado });
            }
            UI.loader("hide");
          })
          .catch((json) => {
            UI.alert(false, json.message);
            UI.loader("hide");
          });
      }
    });
  }

  excluirDocumento(documento, index) {
    UI.confirm(
      "Atenção",
      "Tem certeza que deseja excluir o documento #" + documento.id + "?"
    ).then((confirma) => {
      if (confirma) {
        UI.loader("show", "Um momento...");
        API.delete("/prontuario/documentos/" + documento.id)
          .then((json) => {
            UI.alert(json.success, json.message);
            if (json.success) {
              let resultado = this.state.documentos.filter((value, i, arr) => {
                return i !== index;
              });
              this.setState({ documentos: resultado });
            }
            UI.loader("hide");
          })
          .catch((json) => {
            UI.alert(false, json.message);
            UI.loader("hide");
          });
      }
    });
  }

  render() {
    let styleContraste = {
      border: "1px dashed #777",
      fontWeight: "700",
      background: "#fff",
    };

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">PRONTUÁRIO</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.props.history.push(
                          "/impressao/prontuario/" + this.state.paciente.id
                        );
                      }}
                    >
                      <i className="fa fa-print"></i>&nbsp;Imprimir
                    </button>
                    &nbsp;
                    <button
                      onClick={() => {
                        this.props.history.push(
                          "/paciente/cadastro/" + this.state.paciente.id
                        );
                      }}
                      className="btn btn-info"
                    >
                      <i className="fa fa-edit"></i>&nbsp;Editar
                    </button>
                  </div>
                </div>
                <p className="card-description" />
                {this.state.paciente && (
                  <React.Fragment>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label>Nome Completo</label>
                        <input
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="nome"
                          type="text"
                          className="form-control"
                          value={this.state.paciente.nome}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Sexo</label>
                        <select
                          style={styleContraste}
                          disabled
                          name="sexo"
                          className="form-control"
                          value={this.state.paciente.sexo}
                          onChange={this.handleChange}
                        >
                          <option value="M">MASCULINO</option>
                          <option value="F">FEMININO</option>
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label>ID Cismepar</label>
                        <input
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="idCismepar"
                          className="form-control"
                          value={this.state.paciente.idCismepar}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-3">
                        <label>CPF</label>
                        <InputMask
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="cpf"
                          className="form-control"
                          mask="999.999.999-99"
                          value={this.state.paciente.cpf}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>RG</label>
                        <InputMask
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="rg"
                          className="form-control"
                          mask="99.999.999-9"
                          value={this.state.paciente.rg}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label>Email</label>
                        <input
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="email"
                          className="form-control"
                          value={this.state.paciente.email}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-3">
                        <label>Data Nascimento</label>
                        <InputMask
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="dataNascimento"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.paciente.dataNascimento}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Celular</label>
                        <InputMask
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="telefoneCelular"
                          className="form-control"
                          mask="(99) \99999-9999"
                          value={this.state.paciente.telefoneCelular}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Telefone Residencial</label>
                        <InputMask
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="telefoneResidencial"
                          className="form-control"
                          mask="(99) 9999-9999"
                          value={this.state.paciente.telefoneResidencial}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Telefone Comercial</label>
                        <InputMask
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="telefoneComercial"
                          className="form-control"
                          mask="(99) 9999-9999"
                          value={this.state.paciente.telefoneComercial}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label>Nome Pai</label>
                        <input
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="nomePai"
                          className="form-control"
                          value={this.state.paciente.nomePai}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label>Nome Mãe</label>
                        <input
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="nomeMae"
                          className="form-control"
                          value={this.state.paciente.nomeMae}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-3">
                        <label>CNS</label>
                        <input
                          style={styleContraste}
                          disabled
                          placeholder="NÃO INFORMADO"
                          name="cns"
                          className="form-control"
                          value={this.state.paciente.cns}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Estado Civil</label>
                        <select
                          style={styleContraste}
                          disabled
                          name="estadoCivil"
                          className="form-control"
                          value={this.state.paciente.estadoCivil}
                          onChange={this.handleChange}
                        >
                          <option value={1}>SOLTEIRO (A)</option>
                          <option value={2}>CASADO (A)</option>
                          <option value={3}>SEPARADO (A)</option>
                          <option value={4}>DIVORCIADO (A)</option>
                          <option value={5}>VIÚVO (A)</option>
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label>Classificação</label>
                        <select
                          style={styleContraste}
                          disabled
                          name="classificacao"
                          className="form-control"
                          value={this.state.paciente.classificacao}
                          onChange={this.handleChange}
                        >
                          <option value={0}>NENHUMA</option>
                          <option value={1}>GESTANTE</option>
                          <option value={2}>ESTIMULAÇÃO PRECOCE</option>
                          <option value={3}>CRIANÇA</option>
                          <option value={4}>HIPERTENSÃO</option>
                          <option value={5}>DIABETE</option>
                          <option value={6}>IDOSO</option>
                          <option value={7}>GINECOLOGIA</option>
                          <option value={8}>SAÚDE MENTAL</option>
                        </select>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
        <ProntuarioAtendimentos
          atendimentos={this.state.atendimentos}
          onExcluir={this.excluirAtendimento}
        />
        <ProntuarioReunioes
          reunioes={this.state.reunioes}
          onExcluir={this.excluirReuniao}
        />
        <ProntuarioDocumentos
          paciente={this.state.paciente}
          documentos={this.state.documentos}
          onUploaded={this.uploaded}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(Prontuario);
